module.exports = __webpack_public_path__ + "img/pgsql.597cd41b.png";